export const configToRows = (config = []) => {
    if (config && typeof config === 'object' && !Array.isArray(config)) {
        return Object.entries(config).map(([key, value]) => ({ key, value }));
    }

    if (!Array.isArray(config)) return [];

    return config.flatMap((item) => {
        if (!item || typeof item !== 'object' || Array.isArray(item)) return [];
        return Object.entries(item).map(([key, value]) => ({ key, value }));
    });
};

export const buildConfigPayload = (rows = []) => {
    return rows.reduce((config, { key, value }) => {
        const trimmedKey = String(key || '').trim();
        if (!trimmedKey) return config;
        return { ...config, [trimmedKey]: value };
    }, {});
};

export const emptyConfigRow = () => ({ key: '', value: '' });
